import { createRouter, createWebHashHistory } from "vue-router"
import { useStore } from "@/stores/useStores"
import Api from '@/utils/api'

// 需要用户信息检查的路由
const routesRequiringUserInfoCheck = ['logScore', 'memberhome', 'evafile', 'esgRating', 'esgGrade', 'evaFile', 'evaImprove', 'training', 'esgReg', 
    'report', 'userInfo', 'companyInfo', 'changePass', 'changePhone']

// 需要添加currentIdentity=member的路由
const memberRoutes = ['memberhome', 'esgRating', 'esgGrade', 'evafile', 'evaImprove', 'userInfo', 'companyInfo','changePhone'];
// 需要添加currentIdentity=meinfo的路由
const meinfoRoutes = ['training', 'esgReg', 'report'];

let routes = [
    // 您的路由配置保持不变...
    {
        path: '/',
        name: '',
        component: () => import('../pages/nomember/home.vue')
    },
    {
        path: '/home',
        name: '',
        component: () => import('../pages/nomember/home.vue')
    },
    {
        path: '/consult',
        name: '',
        component: () => import('../pages/nomember/consult.vue')
    },
    {
        path: '/case',
        name: '',
        component: () => import('../pages/nomember/customerCase.vue')
    },
    {
        path: '/service',
        name: '',
        component: () => import('../pages/nomember/service.vue')
    },
    {
        path: '/about',
        name: '',
        component: () => import('../pages/nomember/aboutUs.vue')
    },
    {
        path: '/homeProcess',
        name: 'homeProcess',
        component: () => import('../pages/nomember/homeProcess.vue'),
    },
    {
        path: '/login',
        name: '',
        component: () => import('../pages/login.vue')
    },
    {
        path: '/loghome',
        name: 'loghome',
        component: () => import('../pages/member/logHome.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/infoReg',
        name: 'infoReg',
        component: () => import('../pages/member/infoReg.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/logScore',
        name: 'logScore',
        component: () => import('../pages/member/logScore.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/memberhome',
        name: 'memberhome',
        component: () => import('../pages/member/memberHome.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/esgRating',
        name: 'esgRating',
        component: () => import('../pages/member/esgRating.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/esgGrade',
        name: 'esgGrade',
        component: () => import('../pages/member/esgGrade.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/evafile',
        name: 'evafile',
        component: () => import('../pages/member/evaFile.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/evaImprove',
        name: 'evaImprove',
        component: () => import('../pages/member/evaImprove.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/training',
        name: 'training',
        component: () => import('../pages/member/training.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/esgReg',
        name: 'esgReg',
        component: () => import('../pages/member/esgReg.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/report',
        name: 'report',
        component: () => import('../pages/member/report.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/userInfo',
        name: 'userInfo',
        component: () => import('../pages/member/userInfo.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/companyInfo',
        name: 'companyInfo',
        component: () => import('../pages/member/companyInfo.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/changePass',
        name: 'changePass',
        component: () => import('../pages/member/changePass.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/changePhone',
        name: 'changePhone',
        component: () => import('../pages/member/changePhone.vue'),
        meta: { requiresAuth: true }
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
    const store = useStore()
    const token = localStorage.getItem('token')
    
    // 检查是否需要认证
    const authRequired = to.matched.some(record => record.meta.requiresAuth)
    console.log('token', token, authRequired)
    
    if (authRequired) {
        if (!token) {
            // 没有token，重定向到登录页
            next({
                path: '/login',
                query: { redirect: to.fullPath, currentIdentity: 'login' }
            })
        } else {
            // 并行执行store设置
            await store.setType()
            
            // 检查是否需要用户信息检查
            const routeName = to.name;
            const needsUserInfoCheck = routesRequiringUserInfoCheck.includes(routeName)
            
            // 如果需要用户信息检查，且不是infoReg页面本身
            if (needsUserInfoCheck && routeName !== 'infoReg') {
                try {

                    let isFirstLoginType = localStorage.getItem('isFirstLoginType')

                    console.log(isFirstLoginType == 1)

                    if(isFirstLoginType == null || isFirstLoginType == undefined) {
                        // 并行获取用户信息和第一次登录信息
                        const [res, val] = await Promise.all([
                            Api.getUserInfo(),
                            Api.isFirstLogin()
                        ])

                        const type = (!res.data.name || !res.data.email || !res.data.position) || val.data
                        isFirstLoginType = type ?  1 : 0
                        localStorage.setItem('isFirstLoginType', isFirstLoginType)
                    }

                    if (isFirstLoginType == 1) {
                        console.log(1111)
                        // 直接重定向，不加载目标组件
                        next({
                            path: '/infoReg',
                            query: {
                                currentPage: 'nowelcom',
                                currentIdentity: 'firstloginin'
                            }
                        })
                        return // 重要：直接返回，不执行后续代码
                    }

                } catch (error) {
                    console.error('用户信息检查失败:', error)
                    // 如果检查失败，继续导航，不阻塞用户
                }
            }
            
            // 处理跳转到loghome的情况
            if (routeName === 'loghome') {
                const query = { ...to.query };
                if (query.currentPage !== 'welcome' || query.currentIdentity !== 'firstloginin') {
                    query.currentPage = 'welcome';
                    query.currentIdentity = 'firstloginin';
                    next({
                        path: to.path,
                        query: query,
                        hash: to.hash
                    });
                    return;
                }
            }
            
            // 处理跳转到logScore的情况
            if (routeName === 'logScore') {
                const query = { ...to.query };
                if (query.currentPage !== 'nowelcome' || query.currentIdentity !== 'firstloginin') {
                    query.currentPage = 'nowelcome';
                    query.currentIdentity = 'firstloginin';
                    next({
                        path: to.path,
                        query: query,
                        hash: to.hash
                    });
                    return;
                }
            }
            
            // 处理member身份路由
            if (memberRoutes.includes(routeName)) {
                const query = { ...to.query };
                if (query.currentIdentity !== 'member') {
                    query.currentIdentity = 'member';
                    next({
                        path: to.path,
                        query: query,
                        hash: to.hash
                    });
                    return;
                }
            }
            
            // 处理meinfo身份路由
            if (meinfoRoutes.includes(routeName)) {
                const query = { ...to.query };
                if (query.currentIdentity !== 'meinfo') {
                    query.currentIdentity = 'meinfo';
                    next({
                        path: to.path,
                        query: query,
                        hash: to.hash
                    });
                    return;
                }
            }
            
            next()
        }
    } else {
        // 不需要认证的页面直接放行
        // 处理跳转到login的情况（不需要认证的页面）
        if (to.name === '' && to.path === '/login') {
            const query = { ...to.query };
            if (query.currentIdentity !== 'login') {
                query.currentIdentity = 'login';
                next({
                    path: to.path,
                    query: query,
                    hash: to.hash
                });
                return;
            }
        }
        next()
    }
})

export default router;